export enum LinkedItemMessageType {
  linkedItem = 'linked-item',
  unlinkItem = 'unlink-item',
}
